import { render, staticRenderFns } from "./EventsBannerCreate.vue?vue&type=template&id=172a407c&scoped=true"
import script from "./EventsBannerCreate.vue?vue&type=script&lang=js"
export * from "./EventsBannerCreate.vue?vue&type=script&lang=js"
import style0 from "./EventsBannerCreate.vue?vue&type=style&index=0&id=172a407c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172a407c",
  null
  
)

export default component.exports